// Cart upsell card ("add 4 HeatTrap cups"), see snippets/cart-upsell.liquid.
// Loaded once from the cart drawer and the cart page footer, outside the parts
// Dawn re-renders via innerHTML, so the click handler survives re-renders and
// also works when the card first appears after an add-to-cart.
if (!window.cartUpsellBound) {
  window.cartUpsellBound = true;

  document.addEventListener('click', function (evt) {
    var button = evt.target.closest('[data-cart-upsell-add]');
    if (!button || button.getAttribute('aria-busy') === 'true') return;

    // The drawer re-renders through <cart-drawer-items>, the cart page through
    // <cart-items>; both expose Dawn's getSectionsToRender().
    var cartComponent = button.closest('cart-drawer')
      ? document.querySelector('cart-drawer-items')
      : document.querySelector('cart-items');
    var sections = cartComponent && cartComponent.getSectionsToRender ? cartComponent.getSectionsToRender() : [];

    button.setAttribute('aria-busy', 'true');
    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: Number(button.getAttribute('data-cart-upsell-add')),
        quantity: 1,
        sections: sections.map(function (section) {
          return section.section;
        }),
        sections_url: window.location.pathname,
      }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (state) {
        if (state.status || !state.sections) {
          button.removeAttribute('aria-busy');
          return;
        }
        // Same swap Dawn does after a quantity change (assets/cart.js).
        sections.forEach(function (section) {
          var host = document.getElementById(section.id);
          var html = state.sections[section.section];
          if (!host || !html) return;
          var target = host.querySelector(section.selector) || host;
          var source = new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector);
          if (source) target.innerHTML = source.innerHTML;
        });
        document.dispatchEvent(new CustomEvent('cart-upsell:added'));
      })
      .catch(function () {
        button.removeAttribute('aria-busy');
      });
  });
}
